import { UsageResponse, UsageUsdInfo } from "@/types/usage";

const EMPTY_USAGE_USD: UsageUsdInfo = {
  source: "none",
  monthly_budget_usd: 0,
  monthly_spent_usd: 0,
  monthly_remaining_usd: 0,
  monthly_reset_date: undefined,
  trial_budget_usd: 0,
  trial_spent_usd: 0,
  trial_remaining_usd: 0,
  bonus_balance_usd: 0,
  active_budget_usd: 0,
  active_spent_usd: 0,
  active_remaining_usd: 0,
  total_available_usd: 0,
  would_block_usd: false,
  lifetime_openrouter_cost_usd: 0,
  lifetime_billed_usd: 0,
};

export function getUsageUsdInfo(
  usageData?: UsageResponse | null,
): UsageUsdInfo {
  return {
    ...EMPTY_USAGE_USD,
    ...(usageData?.usage_usd ?? {}),
  };
}

const usdFormatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

export function formatUsd(value?: number | null): string {
  return usdFormatter.format(value ?? 0);
}

export function getUsageProgressPercent(usageUsd: UsageUsdInfo): number {
  const totalPool = usageUsd.active_budget_usd + usageUsd.bonus_balance_usd;
  if (totalPool <= 0) return 0;
  return Math.min(
    100,
    Math.max(0, (usageUsd.total_available_usd / totalPool) * 100),
  );
}
